/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var BuildingOutlineIcon = function BuildingOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M12.9713 3.39561C12.3672 3.06003 11.6327 3.06003 11.0287 3.39561L2.51434 8.1258L3.48563 9.87412L12 5.14392L20.5143 9.87412L21.4856 8.1258L12.9713 3.39561Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 17V11H13V17H11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 21H4V19H20V21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11V17H8V11H6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17V11H18V17H16Z"
  }));
};
export default BuildingOutlineIcon;